import {
	ArrayInput,
	FormTab,
	ReferenceInput,
	SelectInput,
	SimpleFormIterator,
	TextInput
} from "react-admin"
import { getCustomAddButton, getCustomRemoveButton } from "../../components/button"
import { useFormInputStyles } from "../../utils/useFormInputStyles"
import { TabHeader } from "../../utils/TabHeader"

export const EnigmaClue = (props) => {
	const classes = useFormInputStyles()

	return (
		<FormTab label="Aide" {...props}>
			<TabHeader
				title="Messages d'aide au joueur"
				desc={
					<p>
						Quand le joueur doit choisir si une actu est vraie ou fausse, il peut demander de l'aide à Sasha.<br /><br />Décrivez ici la question qu'il peut poser, la réponse qu'il peut obtenir, et ce qu'il peut dire suite à cette réponse.
					</p>
				}
			/>
			<TextInput
				className={classes.hidden}
				disabled
				source="enigmaClue.id"
				label="Id de l'indice"
			/>
			<TextInput
				multiline
				minRows="3"
				source="enigmaClue.request"
				label="Demande du joueur"
			/>
			<TextInput
				className={classes.hidden}
				disabled
				source="enigmaClue.advice.id"
				label="Id de la réponse"
			/>
			<ReferenceInput
				source="enigmaClue.advice.character"
				reference="characters"
				label="Personnage qui donne l'aide"
			>
				<SelectInput optionText="name" helperText="Il est conseillé que ce soit Sasha, car c'est à elle que le joueur demande de l'aide" />
			</ReferenceInput>
			<TextInput
				multiline
				minRows="3"
				source="enigmaClue.advice.content"
				label="Message d'aide donné"
			/>
			<ArrayInput
				name="answers"
				source="enigmaClue.advice.answers"
				label="Retours possibles du joueur suite à l'aide donnée"
				className={"Override-noLabelShrink"}
			>
				<SimpleFormIterator
					disableReordering
					addButton={getCustomAddButton("Ajouter une réponse du joueur")}
					removeButton={getCustomRemoveButton("Supprimer")}
				>
					<TextInput
						className={classes.hidden}
						disabled
						source="id"
						label="Id de la réponse"
					/>
					<TextInput
						multiline
						source="text"
						label="Texte"
					/>
				</SimpleFormIterator>
			</ArrayInput>
		</FormTab>
	)
}
